export const LANGUAGES = ['en', 'ru'] as const;
